import React from 'react';
import styled from 'styled-components';

interface CardProps {
  marginRight?: number;
  marginLeft?: number;
  marginTop?: number;
  marginBottom?: number;
  maxHeight?: number;
  identifier?: string;
  padding?: string;
  display?: string;
  id?: string;
  width?: string;
}

const StyledCard = styled.div`
  border-radius: 4px;
  box-shadow: 0 0 10px 0 rgba(219, 227, 237, 0.41);
  border: solid 2px #fff;
  background-color: #fcfcfc;
  width: ${({ width }): string => (width ? `${width}` : 'auto')};
  padding: ${({ padding }): string => (padding ? `${padding}px` : '20px')};
  margin-right: ${({ marginRight }): string => (marginRight ? `${marginRight}px` : '0')};
  margin-left: ${({ marginLeft }): string => (marginLeft ? `${marginLeft}px` : '0')};
  margin-top: ${({ marginTop }): string => (marginTop ? `${marginTop}px` : '0')};
  margin-bottom: ${({ marginBottom }): string => (marginBottom ? `${marginBottom}px` : '0')};
  max-height: ${({ maxHeight }): string => (maxHeight ? `${maxHeight}px` : 'unset')};
  overflow: ${({ maxHeight }): string => (maxHeight ? 'scroll' : 'unset')};
  display: ${({ display }): string => (display ? 'none' : 'block')};
`;

const Card: React.FC<CardProps> = ({
  children,
  marginRight,
  marginLeft,
  marginTop,
  marginBottom,
  maxHeight,
  identifier,
  padding,
  display,
  id,
  width,
}) => {
  return (
    <StyledCard
      marginRight={marginRight}
      marginLeft={marginLeft}
      marginTop={marginTop}
      marginBottom={marginBottom}
      maxHeight={maxHeight}
      padding={padding}
      display={display}
      id={id}
      width={width}
      data-testid={`StyledCard--${identifier}`}
    >
      {children}
    </StyledCard>
  );
};

export default Card;
